import { Slot } from '../../slots/Slot'
import { nativeWrapperSelector } from '../hasNative'

/** Use to clean up native ads before renderin new ads  */
export const removeStaleNativeAd = ({ wrapper }: Pick<Slot, 'wrapper'>) => {
  const oldNativeAd = wrapper.querySelector(`.${nativeWrapperSelector}`)
  if (oldNativeAd) {
    oldNativeAd.remove()
  }
}
